//DEFAULTS

import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

import stickSite from 'site/site'
import zipSearch from 'site/zipSearch'

$(document).ready(function() {
    stickSite.init()
    zipSearch.init()
})